import { useCallback, useEffect, useState } from "react";
import './App.css';
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cproduct from "./C_product";
import ApiHandler from "./ApiHandler";
import LoaderTri from "./components/Loader/LoaderTri";
import FirmPicker from "./components/FirmPicker";





function Product() {

  const [data, setData] = useState([]);
  const [isProduct, setIsProduct] = useState(false);
  const [comCode, setComCode] = useState(null);

  const [isLoading, setIsLoading] = useState(false)
  const [firmId, setFirmId] = useState(null);

  // AllCompanies is per firm, so the list is loaded for the firm picked in
  // the dropdown rather than for a fixed id. FirmPicker's onReady drives the
  // first load: the group list arrives after mount, so fetching on mount
  // would have no firm to fetch for.
  const loadCompanies = useCallback((clientId) => {
    if (!clientId) {
      setData([]);
      return undefined;
    }

    setIsLoading(true)
    const cancelToken = ApiHandler.cancelToken;
    const source = cancelToken.source();

    ApiHandler.get({

      url: "/api/POPSReports/AllCompanies/" + clientId,
      cancelToken: source.token

    })
      .then(((result) => {
        const array = [];
        let count = 1;
        let temp = [];
        result.forEach(element => {
          temp.push(element);
          count++;
          if (count === 4) {
            array.push(temp);
            temp = [];
            count = 1;
          }

        });
        console.log(array);
        setData(array)
      }))
      .catch(err => {
        console.error(err);
        if (err.response && err.response.status && err.response.status === 401) {
          console.log(err.response);
          //   RefreshTokenHandler();
          //  ToastError("Token has expired Please refresh");
        }

      })
      .finally(() => {
        setIsLoading(false)

      })

    return () => {
      source.cancel()
    }
  }, []);

  // re-run whenever the firm changes
  useEffect(() => {
    const cancel = loadCompanies(firmId);
    return () => {
      if (cancel) cancel();
      setData([]);
    };
  }, [firmId, loadCompanies]);

  const firmHandler = (firm) => setFirmId(firm ? firm.wClientId : null);



  return (
    <div className="mb-3">
      {

        !isProduct && !comCode ?
          <div className=" ">

            <h5 className=" text-center mt-3 ">Company List</h5>
            <p className="text-center compaHint">Tap a company to see its products</p>

            <FirmPicker onReady={firmHandler} onChange={firmHandler} />
            <div className=" "
              style={{
                width: "100%",
                overflowX: "scroll",
              }}
            >
              <Table striped>
                <tbody >
                  {data.map((data, i) => {
                    return <tr key={i}>{data.map(s =>
                      <td
                        className="compa"
                        key={s.compCode}
                        title={"Show products from " + s.name}
                        onClick={(e) => {
                          setComCode(s.compCode);
                          setIsProduct(true);
                          console.log();

                        }}
                      >{s.name} </td>)}
                    </tr>
                  })}

                </tbody>
              </Table>
              {isLoading && <LoaderTri />}

            </div>
          </div>

          :

          <Cproduct comCode={comCode} firmId={firmId} setComCode={() => {
            setComCode(null)
            setIsProduct(false)
          }} />
      }
      <br />
      <br />
      <br />
    </div>)
}
export default Product; 